import React, { Fragment } from "react";
import PT from "prop-types";
import get from "lodash/get";
import { HeroImage } from "../../../atoms/HeroImage";
import StoryDetails from "../gn-story-template/StoryDetails";
import "./image-first-layout.m.css";

const ImageFirstLayout = ({ story }) => {
  const heroImageSlug = get(story, ["hero-image-s3-key"], "");
  return (
    <Fragment>
      {heroImageSlug && (
        <div styleName="image-first-hero">
          <HeroImage story={story} aspectRatio={[[11.1, 4]]} isStoryPageImage />
        </div>
      )}
      <StoryDetails story={story} />
    </Fragment>
  );
};

ImageFirstLayout.propTypes = {
  story: PT.object,
};

export default ImageFirstLayout;
